import React from 'react'
import { cn } from '@/lib/utils'
import { Avatar, AvatarImage } from '@/components/ui/avatar'
import { IconBrandInstagram } from '@tabler/icons-react'

export interface TestimonialAuthor {
  name: string
  handle?: string
  avatar: string
}

export interface TestimonialCardProps {
  author: TestimonialAuthor
  text: string
  href?: string
  className?: string
}

export function TestimonialCard({ author, text, href, className }: TestimonialCardProps) {
  const Card: any = href ? 'a' : 'div'
  return (
    <>
      <Card
        {...(href ? { href } : {})}
        className={cn(
          'flex max-w-[320px] flex-col rounded-lg border-t bg-gradient-to-b from-muted/50 to-muted/10 p-4 text-start transition-colors duration-300 hover:from-muted/60 hover:to-muted/20 sm:max-w-[320px] sm:p-6',
          className
        )}
      >
        <div className="flex items-center gap-3">
          <Avatar className="h-12 w-12">
            <AvatarImage src={author.avatar} alt={author.name} />
          </Avatar>
          <div className="flex flex-col items-start">
            <h3 className="text-md font-semibold leading-none">{author.name}</h3>
            {author.handle && (
              <a
                href={`https://instagram.com/${author.handle.replace(/^@/, '')}`}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:underline"
                title="Abrir Instagram"
              >
                <IconBrandInstagram size={16} className="text-primary" />
                {author.handle}
              </a>
            )}
          </div>
        </div>
        <p className="mt-4 text-sm text-muted-foreground sm:text-md">{text}</p>
      </Card>
    </>
  )
}
